import React from "react";
import Api from "./Api/Communicator";

export default class Servis21 extends React.Component {
  state = {
    filterValue: "",
    data: [
      {
        id: 145274,
        TranspCode: "DPD_API_KLAD",
        PackCode: "100000000",
        DateCreate: "2023-06-22",
        COD: 0.0,
        note: "TEST 123",
        name: "Tester Testovič",
        street: "Testovací 123",
        city: "Testovo",
        zip: "100 00",
        phone: "+420 777 777 777",
        email: "tester@testovic.test",
      },
    ],
  };

  filterFunc = (data) => {
    const fulltext = JSON.stringify(data);
    return (
      fulltext.toUpperCase().indexOf(this.state.filterValue.toUpperCase()) > -1
    );
  };

  render() {
    const { Bs, VARIANT, Icon } = this.props;
    return (
      <>
        <div class="p-3 mb-4 bg-uni rounded">
          <div class="d-flex justify-content-between align-items-start align-items-md-center">
            <div>
              <span class="text-secondary mr-1 me-2">Použité filtry:</span>
              <span>
                <strong>
                  {this.state.filterValue === ""
                    ? "Bez filtru"
                    : this.state.filterValue}
                </strong>
              </span>
            </div>
            <Bs col xs={5} className="d-flex justify-content-end">
              <Bs
                formcontrol
                placeholder="Hledat"
                className="me-2"
                value={this.state.filterValue}
                onChange={(e) => this.setState({ filterValue: e.target.value })}
              />
              <Bs button size="sm" variant="success">
                Překlopit
              </Bs>
            </Bs>
          </div>
          <Bs row className="mt-4">
            <Bs col xs={12} lg={3} className="d-flex justify-content-start">
              <Bs row>
                <Bs col xs={12}>
                  <Bs formtext>Datum od</Bs>
                </Bs>
                <Bs col xs={12}>
                  <Bs
                    formcontrol
                    type="date"
                    placeholder="Hledat"
                    className="me-2"
                    value={this.state.filterValue}
                    onChange={(e) =>
                      this.setState({ filterValue: e.target.value })
                    }
                  />
                </Bs>
              </Bs>
            </Bs>
            <Bs col xs={12} lg={3} className="d-flex justify-content-start">
              <Bs row>
                <Bs col xs={12}>
                  <Bs formtext>Datum do</Bs>
                </Bs>
                <Bs col xs={12}>
                  <Bs
                    formcontrol
                    type="date"
                    placeholder="Hledat"
                    className="me-2"
                    value={this.state.filterValue}
                    onChange={(e) =>
                      this.setState({ filterValue: e.target.value })
                    }
                  />
                </Bs>
              </Bs>
            </Bs>
            <Bs col xs={12} lg={3} className="d-flex justify-content-start">
              <Bs row>
                <Bs col xs={12}>
                  <Bs formtext>Typ přepravy</Bs>
                </Bs>
                <Bs col xs={12}>
                    <Bs brtxselect options={[{label:"DPD_API_KLAD",value: "DPD_API_KLAD"},{label:"DPD_API_KLAD_COD",value: "DPD_API_KLAD_COD"}]} className="w-350" placeholder="Vyber typ přepravy" />
                </Bs>
              </Bs>
            </Bs>
            <Bs col xs={12} lg={3} className="d-flex justify-content-end align-items-end">
              <Bs row>
                <Bs col xs={12}>
                    <Bs button size="sm" variant="success">Vyhledat</Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </div>

        {this.state.data.filter(this.filterFunc).map((e, idx) => (
          <Bs row className="mt-2">
            <Bs col xs={12}>
              <Bs card className="lb-3-warning">
                <Bs cardbody>
                  <Bs row>
                    <Bs col xs={12} lg={4}>
                      <Bs row>
                        <Bs col xs={12}>
                          <Bs small className="text-muted me-2">
                            <strong>Id:</strong>
                          </Bs>
                          <Bs span>{e.id}</Bs>
                        </Bs>
                      </Bs>
                      <Bs row>
                        <Bs col xs={12}>
                          <Bs small className="text-muted me-2">
                            <strong>Typ přepravy:</strong>
                          </Bs>
                          <Bs span>{e.TranspCode}</Bs>
                        </Bs>
                      </Bs>
                      <Bs row>
                        <Bs col xs={12}>
                          <Bs small className="text-muted me-2">
                            <strong>Datum objednávky:</strong>
                          </Bs>
                          <Bs span>
                            {new Date(e.DateCreate).toLocaleDateString()}
                          </Bs>
                        </Bs>
                      </Bs>
                      <Bs row>
                        <Bs col xs={12}>
                          <Bs small className="text-muted me-2">
                            <strong>Celková cena:</strong>
                          </Bs>
                          <Bs span>{e.COD}</Bs>
                        </Bs>
                      </Bs>
                    </Bs>
                    <Bs col xs={12} lg={4}>
                      <Bs row>
                        <Bs col xs={12}>
                          <Bs small className="text-muted me-2">
                            <strong>Jméno:</strong>
                          </Bs>
                          <Bs span>{e.name}</Bs>
                        </Bs>
                      </Bs>
                      <Bs row>
                        <Bs col xs={12}>
                          <Bs small className="text-muted me-2">
                            <strong>Adresa:</strong>
                          </Bs>
                          <Bs span>
                            {e.street}, {e.city} {e.zip}
                          </Bs>
                        </Bs>
                      </Bs>
                      <Bs row>
                        <Bs col xs={12}>
                          <Bs small className="text-muted me-2">
                            <strong>Email:</strong>
                          </Bs>
                          <Bs span>{e.email}</Bs>
                        </Bs>
                      </Bs>
                      <Bs row>
                        <Bs col xs={12}>
                          <Bs small className="text-muted me-2">
                            <strong>Telefon:</strong>
                          </Bs>
                          <Bs span>{e.phone}</Bs>
                        </Bs>
                      </Bs>
                    </Bs>
                    <Bs col xs={12} lg={3}>
                      <Bs row>
                        <Bs col xs={12}>
                          <Bs small className="text-muted me-2">
                            <strong>Číslo přepravy:</strong>
                          </Bs>
                          <Bs span>{e.PackCode}</Bs>
                        </Bs>
                      </Bs>
                      <Bs row>
                        <Bs col xs={12}>
                          <Bs small className="text-muted me-2">
                            <strong>Poznámka:</strong>
                          </Bs>
                          <Bs span>{e.note}</Bs>
                        </Bs>
                      </Bs>
                    </Bs>
                    <Bs col xs={1} className="d-flex align-items-center">
                      <Icon
                        ioellipsisvertical
                        className="fs-20 cursor-pointer"
                      />
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        ))}
      </>
    );
  }
}
